import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  styled,
  Stack
} from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  border: `1px dashed #009FE333`,
  backgroundColor: theme.colors.primary.light,
  boxShadow: '0px 0px 8px 0px #0000001A'
}));

interface IProps {
  description: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

const TopicCard = ({ description, onClick, icon }: IProps) => {
  return (
    <StyledCard>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Stack direction="row" gap={1} alignItems="center">
            {icon && icon}
            <Typography variant="body1" fontSize="12px">
              {description}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </StyledCard>
  );
};

export default TopicCard;
